import React from 'react';
import { Wrench, Clock } from 'lucide-react';

interface MaintenancePageProps {
  message?: string;
}

export const MaintenancePage: React.FC<MaintenancePageProps> = ({ 
  message = "L'application est actuellement en maintenance. Veuillez réessayer plus tard." 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="mb-6 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-amber-500 rounded-full blur-xl opacity-20 animate-pulse"></div>
            <div className="relative bg-amber-500 rounded-full p-6">
              <Wrench className="w-12 h-12 text-white" />
            </div>
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-slate-900 mb-3">
          Maintenance en cours
        </h1>
        
        <div className="flex items-center justify-center text-slate-500 mb-6">
          <Clock className="w-5 h-5 mr-2" />
          <span className="text-sm">Mise à jour en cours</span>
        </div>
        
        <p className="text-slate-600 mb-8 leading-relaxed">
          {message}
        </p>
        
        <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
          <p className="text-xs text-slate-500">
            Notre équipe travaille actuellement sur des améliorations. 
            L'application sera de nouveau disponible très prochainement.
          </p>
        </div>
        
        <div className="mt-8 pt-6 border-t border-slate-200">
          <p className="text-xs text-slate-400">
            Pour toute question urgente, veuillez contacter le support.
          </p>
        </div>
      </div>
    </div>
  );
};
